import { DateRange } from 'react-day-picker'

import { FiltersDefinition, FiltersState, IconType } from '@factorialco/f0-react'
import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'

import { ColumnFormatHint } from 'modules/ai_reports/components/DatasourceTypeRenderer/utils'
import { ReportSchemaType } from 'modules/ai_reports/lib/types'

import TraceabilityTableContent from './TraceabilityTableContent'

interface ReportTableAction {
  label: string
  icon: IconType
  onClick: () => void
}

interface ReportTableProps {
  id: string
  dateFilter?: DateRange
  reportName: string
  sqlQuery: string
  actions?: {
    primary?: ReportTableAction
    secondary?: ReportTableAction[]
  }
  columnFormatHints: ColumnFormatHint[]
  columnOrder: string[] | null
  onStateChange: React.ComponentProps<typeof OneDataCollection>['onStateChange']
  tableId: string
  onUserFacingSqlQueryChange: (sqlQuery: string) => void
  currentFilters: FiltersState<FiltersDefinition<string>> | undefined
  schema: ReportSchemaType
  onSchemaChanged: (schema: ReportSchemaType) => void
}

const ReportTable = ({
  id,
  sqlQuery,
  actions,
  columnFormatHints,
  columnOrder,
  onStateChange,
  tableId,
  dateFilter,
  onUserFacingSqlQueryChange,
  currentFilters,
  schema,
  onSchemaChanged,
}: ReportTableProps) => {
  return (
    <TraceabilityTableContent
      id={id}
      sqlQuery={sqlQuery}
      tableId={tableId}
      actions={actions}
      columnFormatHints={columnFormatHints}
      columnOrder={columnOrder}
      onStateChange={onStateChange}
      dateFilter={dateFilter}
      onUserFacingSqlQueryChange={onUserFacingSqlQueryChange}
      currentFilters={currentFilters}
      currentSchema={schema}
      onSchemaChanged={onSchemaChanged}
    />
  )
}

export default ReportTable
export { type ReportTableAction, type ReportTableProps }
